import DecisionBody from "./DecisionBody";
import DecisionFooter from "./DecisionFooter";
import DecisionHeader from "./DecisionHeader";
import { DecisionHeaderEdit } from "./DecisionEdit";
import PropTypes from "prop-types";
import { StyledDecision } from "../../styles/StyledDecision";
import { getDecision } from "../../api/decision/decision";
import { useQuery } from "react-query";
import { DecisionProvider } from "../../context/decisionContext";
import { QueryLoader } from "../Loader";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const emptyData = {
	isLoading: false,
	isError: false,
	error: false,
	data: {},
};

export default function Decision({ id, newDecision = false, isEditMode, setIsEditMode, prefillData }) {
	const { axiosPrivate } = useAxiosPrivate();
	const { isLoading, isError, error, data, refetch } = newDecision
		? emptyData
		: useQuery(["decision-id", id], () => getDecision(axiosPrivate, id));

	if (isLoading) {
		return <QueryLoader />;
	}
	if (isError) {
		return <div>{error}</div>;
	}

	return (
		<DecisionProvider value={data}>
			<StyledDecision>
				{newDecision || isEditMode ? (
					<DecisionHeaderEdit
						edit={isEditMode}
						disableEditingMode={() => setIsEditMode(false)}
						newDecision={newDecision}
						refetch={refetch}
						prefillData={prefillData}
					/>
				) : (
					<DecisionHeader onClick={() => setIsEditMode(true)} />
				)}

				<DecisionBody edit={newDecision ? true : false} newDecision={newDecision} id={id} prefillData={prefillData}></DecisionBody>
				{!newDecision ? <DecisionFooter id={id} edit={isEditMode} /> : null}
			</StyledDecision>
		</DecisionProvider>
	);
}

Decision.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isEditMode: PropTypes.bool,
	setIsEditMode: PropTypes.func,
	newDecision: PropTypes.bool,
	prefillData: PropTypes.object,
};
